module.exports = __webpack_public_path__ + "static/media/option5-4row.14f53645.png";